import type { ThemeTemplate } from './templates';

export const templateA: ThemeTemplate = {
  id: 'A',
  name: '高端商务风',
  layoutMode: 'business',
  tagline: '专注企业高端团建 · 定制专属团队体验',
  description: '深蓝金配色 · 三列卡片网格 · 渐进式滚动动效 · 专业稳重',
  primary: '#1B3A4B',
  accent: '#C9A96E',
  background: '#FAFAF8',
  secondary: '#E8E2D9',
  textPrimary: '#1B3A4B',
  textSecondary: '#6B7B8D',
  heroGradient: 'linear-gradient(135deg, rgba(27,58,75,0.92) 0%, rgba(27,58,75,0.7) 100%)',
  cardBg: '#FFFFFF',
  cardBorderRadius: 12,
  buttonBorderRadius: 8,
  buttonStyle: 'rounded',
  fontFamily: '"Noto Sans SC", "PingFang SC", system-ui, sans-serif',
  navBg: 'rgba(255,255,255,0.95)',
  navText: '#1B3A4B',
  footerBg: '#1B3A4B',
  footerText: '#94A3B8',
  preview: { primary: '#1B3A4B', accent: '#C9A96E', background: '#FAFAF8' },
};
